import service from './service'
import { assembleItemDetailListV2, assembleMenuV2 } from '../menuV2'

// VUE_APP_DEEP_FREEZE 為 'true' 時凍結組裝出的共用子樹，讓漏網的就地寫入當場拋錯（見 utils/menuV2.js）
const freeze = process.env.VUE_APP_DEEP_FREEZE === 'true'

export default {
	// 取得餐點列表(依分類)。口味、升級、套餐內容皆為唯讀（口味、升級全菜單共用；售況欄位除外），寫入前須先複製（見 utils/menuV2.js）
	getMenu: params =>
		service
			.get(`/back/pos/getMenuV2`, { params, reloadOnMissingRoute: true })
			.then(res => ({
				...res,
				data: assembleMenuV2(res.data, { freeze }),
			})),

	// 取得一筆餐點資訊。需依 errorCode 分辨「餐點已刪除」與載入失敗的呼叫端自帶 rejectWithDetail。
	// 回傳結構同 getMenu 的餐點，口味、升級、套餐內容唯讀，寫入前須先複製。
	getItem: (params, config = {}) =>
		service
			.get(`back/pos/getItemDetailV2`, {
				params,
				reloadOnMissingRoute: true,
				...config,
			})
			.then(res => ({
				...res,
				data: assembleItemDetailListV2(res.data, { freeze })?.[0],
			})),

	// 新增訂單需要依後端 errorCode 判斷是否為菜單過期；
	// rejectWithDetail 只留在 Axios config，不會當成 header 傳到後端。
	addOrder: params =>
		service.post(`back/pos/addOrder`, params, { rejectWithDetail: true }),

	// 列印購物車
	printTag: params => service.post(`back/pos/printTag`, params),

	// 取得餐點庫存資訊
	getItemStock: params => service.get(`back/pos/getItemStock`, { params }),

	// 修改餐點庫存資訊
	updateItemStock: params => service.put(`back/pos/updateItemStock`, params),

	// 批量修改餐點庫存資訊
	batchUpdateItemStock: params =>
		service.put(`back/pos/batchUpdateItemStock`, params),

	// 取得口味細項的名稱關聯（後端為名稱包含比對，可能包含相近名稱）
	getRelatedOptionDetail: params =>
		service.get(`back/pos/getRelatedOptionDetail`, { params }),

	// 批次修改口味細項販售狀態；同一批可同時設售完與恢復販售
	batchUpdateOptionDetailStock: params =>
		service.put(`back/pos/batchUpdateOptionDetailStock`, params),

	// 開啟錢箱
	openCashDrawer: params =>
		service.post(`back/pos/openCashDrawer`, null, { params }),

	// 交付出單機的回報：native 確定要送去列印時觸發，後端據以停止自動重送這張單
	printDelivered: params => service.post(`back/pos/printDelivered`, params),
}
